module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_generator_manual/step3-6bfd3a8ad3c8d961471b27cd00cf75fe.png";